module.exports = __webpack_public_path__ + "static/feri-50c3be8bc86b90bf23d652f0ab9ccad3.png";